import Opinion from 'site/components/Opinion';

export default function OpinionWidget(props) {
  return (
    <Opinion {...props} />
  );
}
